<template>
    <div class="leftGraphics reveal" id="greo">
        <img 
			class ="deviceLeft rellax" 
            src="@/assets/images/device/greo-phone-left.png" 
            alt="iphone-X-black" 
            data-rellax-speed="2.5" 
            data-rellax-percentage="0.5"/>

        <img 
			class ="deviceRight rellax" 
            src="@/assets/images/device/greo-phone-right.png" 
            alt="iphone-X-black" 
            data-rellax-speed="-0.5" 
            data-rellax-percentage="0.5"/>
    </div>
</template>

<script>
import RightColumnComponent from './GreoRight.vue';
import LeftColumnComponent from './GreoLeft.vue';


export default {
    name: 'GreoLeftColumn',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.leftGraphics {
    display: flex;
    flex-direction: row;
}

.deviceLeft {
    width: 65%;
    align-self: flex-start;
    margin-right: -15%;
    z-index: 2;
}

.deviceRight {
    width: 50%;
    align-self: flex-end;
    margin-bottom: 20%;
}

</style>



// WEBPACK FOOTER //
// src/components/Apps/Greo/GreoLeft.vue